import instance from "@/services/api";

export const bimCategoriesAPI = {
  async getList() {
    return await instance().get('/handbook/bim_categories/read/').then(res => res?.data)
  },
  async getTypes(bim_category_id) {
    return await instance().get(`/handbook/bim_categories/${bim_category_id}/types/`).then(res => res?.data)
  },
  async getParams(bim_type_id) {
    return await instance().get(`/handbook/bim_categories/types/${bim_type_id}/params/`).then(res => res?.data)
  },
  async getAllParams() {
    return await instance().get('/handbook/bim_categories/params/all/').then(res => res?.data)
  },
  async getFloorParamTypes() {
    return await instance().get('/handbook/bim_categories/floor-param-types/read/').then(res => res?.data)
  },
  async importJson(file) {
    const formData = new FormData();
    formData.append('json_file', file);
    return await instance().post('/handbook/bim_categories/import/', formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }).then(res => res?.data)
  },
  async importExcelDict(file) {
    const formData = new FormData();
    formData.append('excel_file', file);
    return await instance().post('/handbook/bim_categories/import-excel-dict/', formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }).then(res => res?.data)
  },
  async saveType(data) {
    return await instance().post('/handbook/bim_categories/types/save/', data).then(res => res?.data)
  },
  async deleteType(bim_type_id) {
    return await instance().delete(`/handbook/bim_categories/types/${bim_type_id}/delete/`).then(res => res?.data)
  },
  async saveTypeParam(data) {
    return await instance().post('/handbook/bim_categories/type-params/save/', data).then(res => res?.data)
  },
  async deleteTypeParam(bim_type_param_id) {
    return await instance().delete(`/handbook/bim_categories/type-params/${bim_type_param_id}/delete/`).then(res => res?.data)
  },
  // Групповые действия
  async getParamsByGroup(bim_type_ids) {
    return await instance().post('/handbook/bim_categories/group/params/read/', { bim_type_ids }).then(res => res?.data)
  },
  async deleteParamFromGroup(bim_param_id, bim_type_ids) {
    return await instance().post('/handbook/bim_categories/group/params/delete/', { bim_param_id, bim_type_ids }).then(res => res?.data)
  },
      async setParamsSelectedGroup(bim_param_ids, bim_type_ids, is_active) {
        return await instance().post('/handbook/bim_categories/group/params/set-selected/', { bim_param_ids, bim_type_ids, is_active }).then(res => res?.data)
      }
}

